// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__feML_","logo":"footer_logo___d_IO","innerFooter":"footer_innerFooter__MHs_v","language":"footer_language__OmBN9"};